import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters('UndoActions', [
      'getClassForLastUndoAction',
    ]),
  },
};